import { TStepTabsItem } from '@r1-frontend/ui-react/components/StepMenu/StepTabs';

import * as Page from '~/src/features/tariffBuilder/pages';
import { ESteps } from '~/src/features/tariffBuilder/types/ESteps';
import electricPlug from '~/static/images/tariff-builder/electric-plug.svg';
import film from '~/static/images/tariff-builder/film.svg';
import highVoltage from '~/static/images/tariff-builder/high-voltage.svg';

export type TStep = TStepTabsItem & {
    Page: () => JSX.Element,
} | {
    id: number,
    Page: () => JSX.Element,
};

const steps: Record<ESteps, TStep> = {
    [ESteps.SpeedAndTv]: { id: ESteps.SpeedAndTv, label: 'Скорость и ТВ', Image: highVoltage, Page: Page.SpeedAndTv },
    [ESteps.Subscriptions]: { id: ESteps.Subscriptions, label: 'Подписки', Image: film, Page: Page.Subscriptions },
    [ESteps.Equipment]: { id: ESteps.Equipment, label: 'Оборудование', Image: electricPlug, Page: Page.Equipment },
    // [ESteps.Security]: { id: ESteps.Security, label: 'Безопасность', Icon: Moscow, Page: Page.Security },

    [ESteps.FillAddress]: { id: ESteps.FillAddress, Page: Page.FillAddress },
    [ESteps.FillContacts]: { id: ESteps.FillContacts, Page: Page.FillContacts },
    [ESteps.CreateAgreement]: { id: ESteps.CreateAgreement, Page: Page.CreateAgreement },
    [ESteps.SelectVisitData]: { id: ESteps.SelectVisitData, Page: Page.SelectVisitDate },

    [ESteps.Final]: { id: ESteps.Final, Page: Page.Final },
};

export default steps;
